import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, DatePicker, Input, message, Tag, Checkbox, TimePicker, Select } from "antd";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import moment from "moment";
import config from "../config";

const AttendanceTable = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [filterModalVisible, setFilterModalVisible] = useState(false);
  // const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  // const { Search } = Input;
  // const [searchText, setSearchText] = useState("");
  
  const [staffList, setStaffList] = useState([]);
  const [dateRange, setDateRange] = useState([
    moment().startOf('day'),
    moment().endOf('day')
  ]);
  const [selectedStaff, setSelectedStaff] = useState(null);

  // get staff list
  useEffect(() => {
    const fetchStaffList = async () => {
      try {
        const res = await axios.get(`${apiBaseUrl}/api/users/get-user`);
        setStaffList(res.data);
        console.log("Fetched staff list:", res.data);
      } catch (e) {
        message.error("Failed to fetch staff list");
      }
    };
    fetchStaffList();
  }, []);

  // Fetch all attendance records
  const fetchAttendance = async (range) => {
    let start, end;
    if (range && range[0] && range[1]) {
      start = range[0].format('YYYY-MM-DD');
      end = range[1].format('YYYY-MM-DD');
    } 
    // else {
    //   const today = new Date();
    //   const yyyy = today.getFullYear();
    //   const mm = String(today.getMonth() + 1).padStart(2, '0');
    //   const dd = String(today.getDate()).padStart(2, '0');
    //   start = end = `${yyyy}-${mm}-${dd}`;
    // }
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('startDate', start);
      params.append('endDate', end);
      const response = await axios.get(`${apiBaseUrl}/api/clockinout/attendance?${params.toString()}`);
      setAttendanceData(response.data.data);
      setFilteredData(response.data.data);
    } catch (error) {
      message.error("Failed to fetch attendance data");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const todayRange = [moment().startOf('day'), moment().endOf('day')];
    setDateRange(todayRange);
    fetchAttendance(todayRange);
  }, []);


  // Apply filters
  //   const applyFilters = async (values) => {
  //     try {
  //       setLoading(true);
  //       const params = new URLSearchParams();

  //       //   if (values.staffId) params.append('staffId', values.staffId);
  //       if (values.staffId) params.append('staffIdContains', values.staffId);
  //       if (values.startDate) params.append('startDate', values.startDate.format('YYYY-MM-DD'));
  //       if (values.endDate) params.append('endDate', values.endDate.format('YYYY-MM-DD'));

  //       const response = await axios.get(`${apiBaseUrl}/api/clockinout/attendance?${params.toString()}`);
  //       setFilteredData(response.data.data);
  //       setFilterModalVisible(false);
  //     } catch (error) {
  //       message.error("Failed to apply filters");
  //       console.error(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  // useEffect(() => {
  //   if (searchText) {
  //     setFilteredData(attendanceData.filter(item =>
  //       item.staffId.toLowerCase().includes(searchText.toLowerCase())
  //     ));
  //   } else {
  //     setFilteredData(attendanceData);
  //   }
  // }, [searchText]);

  // Filter data based on selected staff
  useEffect(() => {
    let data = attendanceData;
    if (selectedStaff) {
      data = data.filter(item =>
        item.staffId.toLowerCase() === selectedStaff.toLowerCase()
      );
    }
    setFilteredData(data);
  }, [selectedStaff, attendanceData]);

  // auto retrieve data when the date changes
  const handleDateRangeChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      setDateRange(dates);
      fetchAttendance(dates);
    } else {
      setDateRange([null, null]);
      fetchAttendance(null);
      // setAttendanceData([]);
      // setFilteredData([]);
    }
  };

  // Reset filters
  const resetFilters = () => {
    setDateRange([moment().startOf('day'), moment().endOf('day')]);
    setSelectedStaff(null);
    fetchAttendance([moment().startOf('day'), moment().endOf('day')]);
  };

  // Format duration
  const formatDuration = (minutes) => {
    if (!minutes) return "N/A";
    const hours = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);
    return `${hours}h ${mins}m`;
  };

  // Columns for main attendance table
  const columns = [
    {
      title: "Staff ID",
      dataIndex: "staffId",
      key: "staffId",
      sorter: (a, b) => a.staffId.localeCompare(b.staffId),
      showSorterTooltip: false,
    },
    {
      title: "Staff Name",
      dataIndex: "staffName",
      key: "staffName",
      sorter: (a, b) => a.staffName.localeCompare(b.staffName),
      showSorterTooltip: false,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => moment(date).format("YYYY-MM-DD"),
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      showSorterTooltip: false,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <DatePicker.RangePicker
            value={selectedKeys[0] ? [moment(selectedKeys[0][0]), moment(selectedKeys[0][1])] : []}
            onChange={(dates) => {
              if (dates) {
                setSelectedKeys([[dates[0].startOf('day').toISOString(), dates[1].endOf('day').toISOString()]]);
                confirm({ closeDropdown: false });
              } else {
                setSelectedKeys([]);
                confirm({ closeDropdown: false });
              }
            }}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%' }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => {
        if (!value || !value[0] || !value[1]) return true;
        const recordDate = moment(record.date);
        return recordDate.isBetween(value[0], value[1], null, '[]');
      },
    },
    {
  title: "Clock In",
  children: [
    {
      title: "Time",
      dataIndex: "clockInTime",
      key: "clockInTime",
      render: (time) => moment(time).format("HH:mm:ss"),
    },
    {
      title: "Method",
      dataIndex: "inMethod",
      key: "inMethod",
      render: (method) =>
        method
          ? method === "accessKey"
            ? "Access Key"
            : "Face Recognition"
          : "-",
    },
  ],
},
{
  title: "Clock Out",
  children: [
    {
      title: "Time",
      dataIndex: "clockOutTime",
      key: "clockOutTime",
      render: (time) =>
        time ? moment(time).format("HH:mm:ss") : <Tag color="red">Clocked In</Tag>,
    },
    {
      title: "Method",
      dataIndex: "outMethod",
      key: "outMethod",
      render: (method) =>
        method
          ? method === "accessKey"
            ? "Access Key"
            : "Face Recognition"
          : "-",
    },
  ],
},
    // {
    //   title: "Clock In",
    //   dataIndex: "clockInTime",
    //   key: "clockInTime",
    //   render: (time) => moment(time).format("HH:mm:ss"),
    // },
    // {
    //   title: "Clock Out",
    //   dataIndex: "clockOutTime",
    //   key: "clockOutTime",
    //   render: (time) => (time ? moment(time).format("HH:mm:ss") : <Tag color="red">Clocked In</Tag>),
    // },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (duration) => formatDuration(duration),
      sorter: (a, b) => (a.duration || 0) - (b.duration || 0),
      showSorterTooltip: false,
    },
  ];

  // const staffOptions = React.useMemo(() => {
  //   const map = new Map();
  //   filteredData.forEach(item => {
  //     if (!map.has(item.staffId)) {
  //       map.set(item.staffId, item.staffName);
  //     }
  //   });
  //   return Array.from(map.entries()).map(([userId, name]) => ({ userId, name }));
  // }, [filteredData]);

  const staffOptions = React.useMemo(() => {
    return staffList.map(staff => ({
      userId: staff.userId || staff._id, // 根据你的接口结构选择正确字段
      name: staff.name || staff.staffName || staff.fullName || staff.userName || 'Unknown'
    }));
  }, [staffList]);

  return (
    <DefaultLayout searchPlaceholder="User ID" showSearch={false}>
      {/* Main content wrapper for blur effect */}
      <div className={`clockinout-page-wrapper`}>
        <div className="page-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <h1 className="page-title">Attendance Records</h1>
          {/* <div className="d-flex align-items-center">
            <Button type="primary" onClick={() => setFilterModalVisible(true)}
              style={{ marginRight: 8 }}
            >
              Filter Records
            </Button>
            <Button type="primary" onClick={fetchAttendance}
            >
              Refresh
            </Button>
          </div> */}
        </div>

        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <DatePicker.RangePicker
            className="staff-id-select"
            value={dateRange}
            onChange={handleDateRangeChange}
            style={{ 
              width: 300,
              // height: 48,             
              padding: '4px 12px',    
              boxSizing: 'border-box' 
            }}
            allowClear
            placeholder={["Start Date", "End Date"]}
          />
          <Select
            showSearch
            allowClear
            placeholder="Staff ID"
            style={{ width: 200 }}
            value={selectedStaff || undefined}
            onChange={setSelectedStaff}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {staffOptions.map(staff => (
              <Select.Option key={staff.userId} value={staff.userId}>
                {staff.userId}
              </Select.Option>
            ))}
          </Select>
          <Button onClick={resetFilters}>Refresh</Button>
        </div>
        <Table
          columns={columns}
          dataSource={filteredData}
          bordered
          loading={loading}
          rowKey="_id"
          // scroll={{ x: true }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: filteredData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
          }}
        />
      </div>
      {/* Modal is rendered outside the blurred wrapper so it is not blurred */}
      {/* <Modal
        title="Filter Attendance Records"
        visible={filterModalVisible}
        onCancel={() => setFilterModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setFilterModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="reset" onClick={resetFilters}>
            Reset
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => form.submit()}
            loading={loading}
          >
            Apply Filters
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={applyFilters}>
          <Form.Item name="staffId" label="Staff ID">
            <Input placeholder="Enter staff ID" />
          </Form.Item>
          <Form.Item name="startDate" label="Start Date">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="endDate" label="End Date">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal> */}
    </DefaultLayout>
  );
};

export default AttendanceTable;